import React from "react";

const SkeletonBox = ({ className = "" }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const GoalFormSkeleton: React.FC = () => {
  return (
    <form className="px-6">
      <div className="space-y-5">
        {/* Goal Name */}
        <div>
          <SkeletonBox className="h-5 w-32 mb-3" />
          <SkeletonBox className="h-12 w-full" />
        </div>

        {/* Description */}
        <div>
          <SkeletonBox className="h-5 w-40 mb-3" />
          <SkeletonBox className="h-24 w-full" />
        </div>

        {/* Start and End Dates */}
        <div className="flex gap-4">
          <div className="w-1/2">
            <SkeletonBox className="h-5 w-28 mb-3" />
            <SkeletonBox className="h-12 w-full" />
          </div>
          <div className="w-1/2">
            <SkeletonBox className="h-5 w-28 mb-3" />
            <SkeletonBox className="h-12 w-full" />
          </div>
        </div>

        {/* Reporting Frequency */}
        <div>
          <SkeletonBox className="h-5 w-40 mb-3" />
          <div className="flex items-center w-full gap-4">
            <SkeletonBox className="h-5 w-24" />
            <SkeletonBox className="h-5 w-24" />
          </div>
        </div>

        {/* Projects */}
        <div>
          <SkeletonBox className="h-5 w-24 mb-3" />
          <SkeletonBox className="h-12 w-full rounded-lg" />
          <SkeletonBox className="h-4 w-64 mt-2" />
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end mt-6 gap-3">
        <SkeletonBox className="h-10 w-24 rounded-md" />
        <SkeletonBox className="h-10 w-28 rounded-md" />
      </div>
    </form>
  );
};

export default GoalFormSkeleton;
